import { defineMessages } from 'react-intl';

export default defineMessages({
  quantity: {
    id: 'sentinel.components.transferPanel.quantity',
    defaultMessage: 'Quantity',
  },
  amount: {
    id: 'sentinel.components.transferPanel.amount',
    defaultMessage: 'Amount',
  },
  costBasis: {
    id: 'sentinel.components.transferPanel.costBasis',
    defaultMessage: 'Cost Basis',
  },
  miscIncome: {
    id: 'sentinel.components.transferPanel.miscIncome',
    defaultMessage: 'Misc. Income',
  },
  CUSIP: {
    id: 'sentinel.components.transferPanel.cusip',
    defaultMessage: 'CUSIP',
  },
  TICKER_SYMBOL: {
    id: 'sentinel.components.transferPanel.tickerSymbol',
    defaultMessage: 'Ticker Symbol',
  },
  OCC_SYMBOL: {
    id: 'sentinel.components.transferPanel.occSymbol',
    defaultMessage: 'OCC Symbol',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferPanelPositionJournal/messages.js